module.exports = __webpack_public_path__ + "img/plus.87169803.png";